module.exports = __webpack_public_path__ + "images/external_images/img/clients/airbnb-white.png";